/** How long before the prompt opens itself again. The tab on the page edge is always there. */
export const ANSWERED_QUIET_DAYS = 30;
export const DISMISSED_QUIET_DAYS = 90;

const DAY_MS = 24 * 60 * 60 * 1000;

interface SurfaceHistory {
   answeredAt?: number;
   dismissedAt?: number;
}

export type PromptHistory = Record<string, SurfaceHistory>;

function isWithin(timestamp: number | undefined, days: number, now: number): boolean {
   return timestamp !== undefined && now - timestamp < days * DAY_MS;
}

/** History is per browser, so someone on two machines can be asked twice. */
export function canAutoOpen(history: PromptHistory, surface: string, now: number): boolean {
   const entry = history[surface];
   if (!entry) {
      return true;
   }

   return (
      !isWithin(entry.answeredAt, ANSWERED_QUIET_DAYS, now) &&
      !isWithin(entry.dismissedAt, DISMISSED_QUIET_DAYS, now)
   );
}

export function recordAnswered(
   history: PromptHistory,
   surface: string,
   now: number
): PromptHistory {
   return { ...history, [surface]: { ...history[surface], answeredAt: now } };
}

export function recordDismissed(
   history: PromptHistory,
   surface: string,
   now: number
): PromptHistory {
   return { ...history, [surface]: { ...history[surface], dismissedAt: now } };
}
